import { fromType } from "@src/store/helpers";
import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { snowFlakeBaseUrl } from "@src/store/ApiProvider";
import { RootState } from "@src/store/store";
import { createSelector } from "@reduxjs/toolkit";
import { _selectSelectedSectionNames } from "@src/store/map/mapSlice";
import { useActiveChartData } from "@src/hooks/useChartData";

export type TActiveList = {
	date: string;
	averagePrice: number;
	getInPrice: number;
	listingsCount: number;
};

export type ExpandedTActiveList = TActiveList & { section: string };

export type TActiveInitialState = {
	eventData: Array<TActiveList>;
	sectionData: Array<ExpandedTActiveList>;
};

const initialState = fromType<TActiveInitialState>({
	eventData: [],
	sectionData: [],
});

export const { thunk: getActiveChartsPlus, slice: getActiveChartsPlusSlice } = getThunkAndSlice<
	{
		eventId: number;
	},
	typeof initialState
>({
	initialState,
	externalPath: ({ eventId }) => `${snowFlakeBaseUrl}/active-listings?eventId=${eventId}`,
	path: ({ eventId }) => `/api/activeCharts/${eventId}/data`,
	cacheId: "eventId",
});

const selectActiveChartData = (state: RootState) => state.marketplace.seatgeek.activeCharts;

export const selectAggregatedActiveChartData = createSelector(
	[selectActiveChartData, _selectSelectedSectionNames],
	(activeChart, selectedSections) => {
		return {
			activeChartLoading: activeChart.loading,
			filteredActiveChartData: useActiveChartData({ rawSections: selectedSections, data: activeChart.data }),
		};
	},
);
